import { Route } from "react-router-dom";
import Signup from "../Modules/Auth/Signup";
import ResetPassword from "../Modules/Auth/ResetPassword";
import ForgotPassword from "../Modules/Auth/ForgetPassword";
import AuthActions from "../Modules/Auth/Components/auth-actions";
import AuthUserActions from "../Modules/Auth/authUserActions";
import React, { lazy, Suspense } from "react";
import LoginLoader from "../components/Login/LoginLoader.jsx";
const Login3d = lazy(() => import("../components/Login/Login3d"));

const authRoutes = [
  <Route key={'SignUpRoute'} path="/signUp" element={<Signup />} />,
  <Route
    key="LoginRoute"
    path="/login"
    element={
      <Suspense fallback={<LoginLoader />}>
        <Login3d />
      </Suspense>
    }
  />,
  <Route key={'ForgotPasswordRoute'} path="/forgetPassword" element={<ForgotPassword />} />,
  <Route key={'PasswordResetRoute'} path="/password-reset" element={<ResetPassword />} />,
  <Route key={'AuthActionRoute'}
    path="/auth/action"
    element={
      <AuthActions>
        <AuthUserActions />
      </AuthActions>
    }
  />,
];

export default authRoutes;
